import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
    color: red;
`;

/* eslint-disable react/prefer-stateless-function */
export class FieldError extends React.Component {
    get errors() {
        return this.props.errors ?? null;
    }

    render() {
        return (this.errors &&
            <Container>
                {this.errors.map((err, i) => <p key={i}>{err}</p>)}
            </Container>
        );

    }
}
